import { ActionsUnion, createAction } from '../../../redux/customActions';

export const Actions = {
    userInfoTokenFetching: () => createAction('userInfo/tokenRequested'),
    userInfoTokenFailed: () => createAction('userInfo/tokenRequestFailed'),
    userInfoTokenRetrieved: () => createAction('userInfo/tokenReceived'),
};

export type ActionsType = ActionsUnion<typeof Actions>;
